<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <div v-else>
        <Districts :regionId="regionId" />
    </div>
</template>

<script>
import currentUserQuery from '@views/Districts/Browse/queryCurrentUser.graphql';

import Districts from '../Districts/Browse.vue';

export default {
  name: 'DistrictsContainer',
  props: {
    regionId: {
      required: true,
    },
  },
  components: {
    Districts,
  },
  apollo: {
    currentUser: {
      query: currentUserQuery,
    },
  },
  watch: {
    currentUser() {
      const validRole = ['developer', 'admin', 'association'].includes(this.currentUser.role.name);

      if (!validRole) {
        this.$notifyFailure('Not allowed.');
        setTimeout(() => this.$router.push({ name: 'dashboard' }), this.$redirectTimeout);
      }
    },
  },
  data() {
    return {
      currentUser: null,
      loading: 0,
    };
  },
};
</script>
